import dayjs from "dayjs";
import { GROUPED_CHART_COLOURS } from "../../../../../../../shared/lib/constants";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useEffect, useState } from "react";
import {
  formatToDecimal,
  formatToEurosCurrency,
  formatToTwoDecimalPlaces,
} from "../../../../../../../shared/lib/utils";

const MetricsChartByDimension = ({
  data,
  xAxisMinValue,
  xAxisMaxValue,
  selectedMetric,
}) => {
  const formatDate = (date) => new dayjs(date * 1000).format("DD-MM-YYYY");

  const [dataKeys, setDataKeys] = useState([]);

  const barColorByIndex = (index) =>
    GROUPED_CHART_COLOURS[index % GROUPED_CHART_COLOURS.length];

  const formatSelectedMetric = (value) => {
    switch (selectedMetric?.value) {
      case "investment":
      case "revenue":
        return formatToEurosCurrency(value);
      case "impressions":
      case "clicks":
      case "sessions":
      case "newUsers":
      case "bounces":
        return formatToDecimal(value);
      case "conversions":
        return formatToTwoDecimalPlaces(value);
      default:
        return value;
    }
  };

  useEffect(() => {
    const newDataKeys = [];
    for (const index in data) {
      const item = data[index];
      const keys = Object.keys(item).filter((key) => key !== "date");
      newDataKeys.push(...keys);
    }
    setDataKeys([...new Set(newDataKeys)]);
  }, [data]);

  return (
    <div id="groupedMetricsChartContainer" className="flex flex-row w-full">
      <BarChart
        width={
          document.getElementById("groupedMetricsChartContainer")?.offsetWidth
        }
        height={300}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          type="number"
          domain={[
            new dayjs(xAxisMinValue).subtract(1, "day").unix(),
            new dayjs(xAxisMaxValue).unix(),
          ]}
          tickFormatter={(value) => formatDate(value)}
        />
        <YAxis />
        <Tooltip
          labelFormatter={(label) => `Fecha: ${formatDate(label)}`}
          formatter={(value) => formatSelectedMetric(value)}
        />
        <Legend />
        {dataKeys &&
          dataKeys.map((dataKey, index) => {
            return (
              <Bar
                key={`bar_${dataKey}_${index}`}
                type="monotone"
                dataKey={dataKey}
                stackId="a"
                fill={barColorByIndex(index)}
                barSize={15}
                maxBarSize={15}
              />
            );
          })}
      </BarChart>
    </div>
  );
};

export default MetricsChartByDimension;
